import * as React from 'react'
import type { CSSProperties } from 'react'
import { cn } from '../lib'
import { designTokens } from '../lib/design-tokens'
import { typographyStyle } from '../lib/catalog'

const Input = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  ({ className, type = 'text', style, ...props }, ref) => {
    type InputTokenStyle = CSSProperties & { [key in `--input-${string}`]?: string }
    const tokenStyle: InputTokenStyle = {
      '--input-bg': designTokens.colors.background.inputDefault,
      '--input-bg-disabled': designTokens.colors.background.inputDisabled,
      '--input-border': designTokens.colors.border.inputDefault,
      '--input-border-focus': designTokens.colors.border.inputFocus,
      '--input-border-disabled': designTokens.colors.border.inputDisabled,
      '--input-text': designTokens.colors.text.inputValue,
      '--input-text-disabled': designTokens.colors.text.inputDisabled,
      '--input-placeholder': designTokens.colors.text.inputPlaceholder,
      '--input-ring': designTokens.colors.border.inputFocus,
      '--input-ring-offset': designTokens.colors.background.inputDefault,
      borderRadius: designTokens.borders.radius.sm,
      borderWidth: designTokens.borders.widths.thin,
      borderStyle: designTokens.borders.styles.solid,
      padding: `${designTokens.spacing.xs} ${designTokens.spacing.sm}`,
      fontFamily: designTokens.typography.fontFamilies.primary,
      ...typographyStyle(designTokens.typography.input.text),
    }

    return (
      <input
        ref={ref}
        type={type}
        className={cn(
          'flex h-10 w-full border border-[var(--input-border)] bg-[var(--input-bg)] text-[var(--input-text)] placeholder:text-[var(--input-placeholder)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--input-ring)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--input-ring-offset)] focus-visible:border-[var(--input-border-focus)] disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-[var(--input-bg-disabled)] disabled:text-[var(--input-text-disabled)] disabled:border-[var(--input-border-disabled)]',
          className
        )}
        style={{ ...tokenStyle, ...style }}
        {...props}
      />
    )
  }
)
Input.displayName = 'Input'

export { Input }
